<template>
  <modal
    :name="name"
    :height="height"
    :width="width"
    :pivot-y="pivotY"
    :clickToClose="clickToClose"
    @opened="opened"
  >
    <button
      type="button"
      class="closeButton"
      @click="close">
    </button>
    <div class="container v--modal-container" id="modal-container">
      <slot></slot>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'app-modal',

    props: {
      name: {
        type: String,
        required: true
      },

      height: {
        type: [String, Number],
        default: 'auto'
      },

      width: {
        type: [String, Number],
        default: 800
      },

      pivotY: {
        type: Number,
        default: 0.5
      },

      clickToClose: {
        type: Boolean,
        default: true
      }
    },

    data () {
      return {
        screenWidth: document.body.clientWidth || document.documentElement.clientWidth
      }
    },

    methods: {
      opened () {
        let modalContent = document.querySelector('.modal-content')
        modalContent.style.height = 'auto'
        let modalBox = document.querySelector('.v--modal-box')
        let modalTitle = document.querySelector('.modal-title')
        let modalBoxHeight = modalBox.offsetHeight
        let modalTitleHeight = modalTitle.offsetHeight
        modalContent.style.height = modalBoxHeight - modalTitleHeight - 30 + 'px'
      },

      open () {
        this.$modal.show(this.name)
      },

      close () {
        this.$emit('after-closed')
        this.$modal.hide(this.name)
      }
    },

    watch: {
      'screenWidth': function (newVal) {
        let modal = document.querySelector('.v--modal-overlay')
        if (newVal && modal) {
          this.opened()
        }
      }
    },

    mounted () {
      this.$bus.$on('screen-width-changed', () => {
        this.screenWidth = document.body.clientWidth || document.documentElement.clientWidth
      })
      let that = this
      window.onresize = function () {
        that.screenWidth = document.body.clientWidth || document.documentElement.clientWidth
      }

      this.$bus.$off('open-modal').$on('open-modal', (modalName) => {
        if (modalName) {
          this.$modal.show(modalName)
        } else {
          this.open()
        }
      })
      this.$bus.$off('close-modal').$on('close-modal', (modalName) => {
        if (modalName) {
          this.$modal.hide(modalName)
        } else {
          this.close()
        }
      })
    },

    beforeDestroy () {
      this.$bus.$off('screen-width-changed')
      // this.$bus.$off('open-modal')
      // this.$bus.$off('close-modal')
    }
  }
</script>

<style lang="scss">
  .v--modal-overlay {
    z-index: 10000 !important;

    .v--modal-box {
      line-height: 1.5;
      left: 0 !important;
      margin: 0 auto;
      max-width: calc(100vw - .2rem);
      max-height: calc(100vh - .2rem);

      .closeButton {
        position: absolute;
        right: .15rem;
        top: .15rem;
      }

      .v--modal-container {
        padding: .15rem;

        .modal-title {
          font-size: .17rem;
          line-height: .2rem;
          padding-right: .25rem;
          padding-bottom: .15rem;
        }

        .modal-content {
          overflow: auto;
          max-height: 4.5rem;
        }

        h4 {
          margin-bottom: .2rem;
        }

        li {
          font-weight: 400;
          margin-bottom: .1rem;
        }

        p {
          margin-bottom: .1rem;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
</style>
